import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importCardOnboardingContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "CardOnboardingContainer" */
                '@perpay-web/fintech/components/containers/CardOnboardingContainer'
            ),
    );
